import { useQuery } from '@tanstack/react-query';
import { userQueryKeys } from '../all-query-keys';
import { getUsers } from '../../../services/UserService';

export const useGetUsers = (name = '') => {
  const { data, isLoading } = useQuery({
    queryKey: userQueryKeys.users(name),

    queryFn: () => getUsers(name),
    enabled: !!name,
  });

  console.log(data);

  const users = data?.data?.content || [];
  return { users, loading: isLoading };
};
